import { render, staticRenderFns } from "./FrootWheelNavigation.vue?vue&type=template&id=46d9e40d&scoped=true"
import script from "./FrootWheelNavigation.vue?vue&type=script&lang=js"
export * from "./FrootWheelNavigation.vue?vue&type=script&lang=js"
import style0 from "./FrootWheelNavigation.vue?vue&type=style&index=0&id=46d9e40d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9e40d",
  null
  
)

export default component.exports